import { EntryType } from '@marketplace-web/shared/photo-tips'
import { PhotoTipsResp } from 'types/api/response/photo-tips-resp'

import { api } from './api'

export const getPhotoTips = (entryType = EntryType.Default) =>
  api.get<PhotoTipsResp>('/photo_tips', {
    params: { entry_type: entryType },
  })
